import { Button, Checkbox, Col, Input, message, Popconfirm, Row } from "antd";
import { GoogleOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";

export default function LoginProfilesFunction(props) {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const [sheetURL, setSheetURL] = useState('');
  const [sheetName, setSheetName] = useState('');

  const [changeLanguage, setChangeLanguage] = useState(true);
  const [changeRecovery, setChangeRecovery] = useState(true);
  const [isChangePassword, setIsChangePassword] = useState(true);

  const [isCreateAccts, setIsCreateAccts] = useState(true);
  const [addMore, setAddMore] = useState(false);
  const [quantity, setQuantity] = useState('50');
  const [tabsNum, setTabsNum] = useState('5');

  const login = async (profile) => {
    if(!sheetURL || !sheetName) {
      alert("Data GG Sheet chưa nhập !!!")
      return;
    }
    
    messageApi.info(`>>> Login Profiles...`);
    let body = {
      sheet: {
        sheetId: sheetURL.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName,
      },
      changeLanguage,
      changeRecovery,
      isChangePassword,
      isCreateAccts,
      quantity,
      addMore,
      tabsNum
    };
    axios
      .post(`${API_HOST}/api/login-profiles`, body)
      .then((res) => messageApi.success("Đang chạy..."))
      .catch((e) => {
        console.log("🚀 ~ Login Profiles ~ error:", e);
        messageApi.error(e.response.data);
      });
  };
  useEffect(() => {
    let sheetName = localStorage.getItem('login-profile-sheetName')
    if(sheetName) {
      setSheetName(sheetName)
    }
    let sheetURL = localStorage.getItem('login-profile-sheetURL')
    if(sheetURL) {
      setSheetURL(sheetURL)
    }
    let isCreateAccts = localStorage.getItem('login-profile-isCreateAccts')
    if(isCreateAccts) {
      setIsCreateAccts(isCreateAccts == 'true')
    }
    let quantity = localStorage.getItem('login-profile-quantity')
    if(quantity) {
      setQuantity(quantity)
    } 
    let tabsNum = localStorage.getItem('login-profile-tabs')
    if(tabsNum) {
      setTabsNum(tabsNum)
    }
  }, [])

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: '500px' }}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Xác nhận: Login Profiles"
        description={
          <div style={{ width: '500px' }}>
            <b>Data GG sheet: </b>
            <Row>
              <Col span={2}>
                <label>URL: </label>
              </Col>
              <Col span={22}>
               <Input
                  value={sheetURL}
                  style={{ width: 400 }}
                  placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                  onChange={(e) => {
                    setSheetURL(e.target.value);
                    localStorage.setItem('login-profile-sheetURL', e.target.value);
                  }}
                />
              </Col>
              <Col span={2}>
                <label>Trang: </label>
              </Col>
              <Col span={22}>
                 <Input
                    value={sheetName}
                    style={{ width: 200 }}
                    placeholder="LOGIN EMAIL"
                    onChange={(e) => {
                      setSheetName(e.target.value);
                      localStorage.setItem('login-profile-sheetName', e.target.value);
                    }}
                  />
              </Col>
              <Col span={14}>
                  <label>Đổi ngôn ngữ</label>
              </Col>
              <Col span={10}>
                  <Checkbox checked={changeLanguage} onChange={e => {
                    setChangeLanguage(e.target.checked)
                    localStorage.setItem("login-profile-changeLanguage", e.target.checked+'');
                  }}>
                  </Checkbox>
              </Col>
              <Col span={14}>
                  <label>Đổi Recovery</label>
              </Col>
              <Col span={10}>
                  <Checkbox checked={changeRecovery} onChange={e => {
                    setChangeRecovery(e.target.checked)
                    localStorage.setItem("login-profile-changeRecovery", e.target.checked+'');
                  }}>
                  </Checkbox>
              </Col>
              <Col span={14}>
                  <label>Đổi Password</label>
              </Col>
              <Col span={10}>
                  <Checkbox checked={isChangePassword} onChange={e => {
                    setIsChangePassword(e.target.checked)
                    localStorage.setItem("login-profile-isChangePassword", e.target.checked+'');
                  }}>
                  </Checkbox>
              </Col>
              <Col span={14}>
                  <label><b>Tạo TK Ads Sau Khi Login</b></label>
              </Col>
              <Col span={10}>
                  <Checkbox checked={isCreateAccts} onChange={e => {
                    setIsCreateAccts(e.target.checked)
                    localStorage.setItem("login-profile-isCreateAccts", e.target.checked+'');
                  }}>
                  </Checkbox>
              </Col>
              <Col span={14}>
                  <label>Tạo thêm</label>
              </Col>
              <Col span={10}>
                  <Checkbox checked={addMore} onChange={e => {
                    setAddMore(e.target.checked)
                    localStorage.setItem("login-profile-addMore", e.target.checked+'');
                  }}>
                  </Checkbox>
              </Col>
              <Col span={4}>
                <label>SL TK: </label>
              </Col>
              <Col span={20}>
                <Input
                  value={quantity}
                  style={{ width: 100 }}
                  placeholder="Số Lượng TK tạo..."
                  onChange={(e) => {
                    setQuantity(e.target.value);
                    localStorage.setItem('login-profile-quantity', e.target.value);
                  }}
                />
              </Col>
 


              <Col span={4}>
                <label>SL Chrome: </label>
              </Col>
              <Col span={20}>
                <Input
                  value={tabsNum}
                  style={{ width: 100 }}
                  placeholder="Số Lượng Chrome..."
                  onChange={(e) => {
                    setTabsNum(e.target.value);
                    localStorage.setItem('login-profile-tabs', e.target.value);
                  }}
                />
              </Col>
            </Row>
          </div>
        }
        onConfirm={() => login(props.profile)}
      >
        <Button type="primary"><GoogleOutlined />Login</Button>
      </Popconfirm>
    </>
  );
}